
const rtranslate = (intl, text) => {
    const txt = text.replace(".", "_");    
    return intl.formatMessage({id : txt});
}

export default rtranslate;